var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"window-control"},[_c('ul',{staticClass:"window-control-links is-horizontal-list"},_vm._l((_vm.panes),function(item){return _c('li',{key:item.id},[_c('a',{class:{ 'is-active': _vm.activePane[item.id] },on:{"click":function($event){return _vm.setActivePane(item.id)}}},[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }